module.exports = __webpack_public_path__ + "img/zdh-icon.6f4ff967.png";